/** saves BatchFiles List
@payload { Array } https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_internetcardtopupbatchFiles
*/
export const SAVE_BATCHFILES = (state, { pageNumber, data }) => {
    state.batchFilesList = pageNumber === 1 ? data.list : state.batchFilesList.concat(data.list)
    state.batchFilesHasMore = data.hasMore
}

/* ***********************************************
*                  CLEAR MUTATIONS               *
*********************************************** */
export const CLEAR_FEATURE_STATE = (state, payload) => {
    state.batchFilesList = []
    state.batchFilesHasMore = true
}
